module.exports = __webpack_public_path__ + "img/08982391800146.86860f91.png";